
import React from 'react';
import { Facebook, Twitter, Linkedin, MessageCircle, Mail } from 'lucide-react';
import ShareOption from './ShareOption';

export interface ShareOptionsGridProps {
  title?: string;
  url?: string;
  options?: {
    name: string;
    icon: React.ReactNode;
    href: string;
    color: string;
  }[];
}

const ShareOptionsGrid: React.FC<ShareOptionsGridProps> = ({ title, url, options }) => {
  // If options are provided, use them directly
  if (options) {
    return (
      <div className="grid grid-cols-5 gap-2" role="group" aria-label="Teilen-Optionen">
        {options.map((item, index) => (
          <ShareOption 
            key={index} 
            icon={item.icon} 
            label={item.name} 
            handler={() => window.open(item.href, '_blank')} 
            index={index} 
          />
        ))}
      </div>
    );
  }

  // Default share handlers if no options are provided
  const handleFacebookShare = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url || '')}`, '_blank');
  };

  const handleTwitterShare = () => {
    window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url || '')}&text=${encodeURIComponent(title || '')}`, '_blank');
  };

  const handleLinkedInShare = () => {
    window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url || '')}`, '_blank');
  };

  const handleWhatsAppShare = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(`${title || ''}\n\n${url || ''}`)}`, '_blank');
  };

  const handleMailShare = () => {
    window.location.href = `mailto:?subject=${encodeURIComponent(title || '')}&body=${encodeURIComponent(`Ich denke, dieser Artikel könnte dich interessieren: ${title || ''}\n\n${url || ''}`)}`;
  };

  const shareOptions = [
    { icon: <Facebook className="h-4 w-4" />, label: "Facebook", handler: handleFacebookShare },
    { icon: <Twitter className="h-4 w-4" />, label: "Twitter", handler: handleTwitterShare },
    { icon: <Linkedin className="h-4 w-4" />, label: "LinkedIn", handler: handleLinkedInShare },
    { icon: <MessageCircle className="h-4 w-4" />, label: "WhatsApp", handler: handleWhatsAppShare },
    { icon: <Mail className="h-4 w-4" />, label: "E-Mail", handler: handleMailShare },
  ];

  return (
    <div className="grid grid-cols-5 gap-2" role="group" aria-label="Teilen-Optionen">
      {shareOptions.map((option, index) => (
        <ShareOption 
          key={index} 
          icon={option.icon} 
          label={option.label} 
          handler={option.handler} 
          index={index} 
        />
      ))}
    </div>
  );
};

export default ShareOptionsGrid;
